import { useEffect, useState } from "react";
import { Grid, KpiCard } from "../../../../components";
import { MonitorFaturamentoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

const defaultEstoque = {
  valorFinanceiro: 0,
  quantidadeItens: 0,
  custoMedio: 0,
  maioresGrupos: [],
};

function MonitorFatEstoque({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [estoque, setEstoque] = useState(defaultEstoque);

  useEffect(() => {
    buscarEstoque();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody?.filtros?.empresasIds]);

  async function buscarEstoque() {
    setLoading(true);
    const result = await monitorFaturamentoService.estoque(filtrosBody);
    if (!result.isAxiosError) {
      setEstoque(result.data || defaultEstoque);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const cards = [
    {
      title: "Valor Financeiro em Estoque",
      value: formatPrice(estoque.valorFinanceiro),
      icon: "ph-currency-dollar",
      color: "#1976d2",
    },
    {
      title: "Itens em Estoque",
      value: (estoque.quantidadeItens || 0).toLocaleString("pt-br"),
      icon: "ph-cube",
      color: "#388e3c",
    },
    {
      title: "Custo Médio do Estoque",
      value: formatPrice(estoque.custoMedio),
      icon: "ph-calculator",
      color: "#f57c00",
    },
  ];

  const itensGrupos = (estoque.maioresGrupos || []).map((g) => ({
    key: g.grupoProdutoId ?? "sem-grupo",
    label: g.nomeGrupoProduto ?? "Sem grupo",
    valor: g.valor,
  }));

  return (
    <Grid container spacing={2} alignItems="stretch">
      <Grid item xs={12} md={5} className="d-flex align-items-stretch ">
        <Grid container spacing={2}>
          {cards.map((card) => (
            <Grid key={card.title} item xs={12}>
              <KpiCard
                title={card.title}
                value={card.value}
                icon={card.icon}
                color={card.color}
                loading={loading}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} md={7}>
        <MonitorFatCard
          titulo="Maiores Grupos em Estoque"
          icone="ph-package"
          loading={loading}
        >
          <MonitorFatRankingBarra itens={itensGrupos} corBarra="#6d4c41" />
        </MonitorFatCard>
      </Grid>
    </Grid>
  );
}

export default MonitorFatEstoque;
